export default __webpack_public_path__ + "static/media/cap_original.cc5bcc99.jpg";